import { guideUsersToRechargeIfOweFees } from '@/common/copyright/account'
import { validateOpusDetailApi, downloadOpusApi } from '@/api/copyright/common'
import { mapState, mapActions } from 'vuex'
import { fuzzySearch, generateUUID } from '@/common/copyright/utils'
import Vue from 'vue'
import Store from '@/store'
export default {
    computed: {
        ...mapState({
            userInfo: (state) => state.userInfo.me,
        }),
    },
    methods: {
        ...mapActions({
            getBalanceInfo: 'balance/getBalanceInfo',
        }),
        // 判断是否有效
        validValue (value) {
            if (value === undefined || value === null) {
                return false
            } else {
                return true
            }
        },
        sleep (delay = 3000) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve()
                }, delay)
            })
        },
        /**
         * 查看详情 specialStatus storeExpired
         * chooseOnlineFilesDialog 不能直接访问 $router $store
         */
        gotoDetailCommon ({ row, specialStatus } = {}, fromArea, condition) {
            let id = row.dataId || row.id
            this.$emit('on-actions', {
                type: 'gotoDetail',
            })
            this.$TsaIframeDialog.show({
                params: {
                    id
                },
                onActions: async (res) => {
                    //console.log(res)
                    let { result, source, origin } = res
                    // 权限禁止
                    // static onForbidden = 'onForbidden'
                    // 接口超时
                    // static onTimeout = 'onTimeout';
                    // 接口登录异常
                    // static onLoginException = 'onLoginException';
                    // 接口请求成功
                    // static onDetailApiSuccess = 'onDetailApiSuccess';
                    // 接口请求失败
                    // static onDetailApiFail = 'onDetailApiFail';
                    // // 弹窗关闭
                    // static onClose = 'onClose'
                    // // 修改备注成功
                    // static onEditRemarkSuccess = 'onEditRemarkSuccess'
                    // // 删除原件成功
                    // static onDeleteOriginFileSuccess = 'onDeleteOriginFileSuccess'
                    // // 原文件上传成功
                    // static onUploadOriginFileSuccess = 'onUploadOriginFileSuccess'
                    // // 分享成功
                    // static onShareSuccess = 'onShareSuccess'
                    // // 停止分享
                    // static onStopShare = 'onStopShare'
                    // 更新Balance
                    // static onUpdateBalance = 'onUpdateBalance'
                    let { type, data } = result
                    switch (type) {
                        case 'onMountedFail':
                            this.$TsaIframeDialog.hide()
                            break
                        case 'onForbidden':
                            await this.sleep()
                            this.$TsaIframeDialog.hide()
                            break
                        case 'onTimeout':
                            await this.sleep()
                            this.$TsaIframeDialog.hide()
                            break
                        case 'onLoginException':
                            await this.sleep()
                            this.$TsaIframeDialog.hide()
                            break
                        case 'onDetailApiSuccess':
                            // 检测到存储到期
                            if (specialStatus === 'storeExpired') {
                                console.log('存储到期')
                                source.postMessage({
                                    type: 'AcceptStoreExpired',
                                }, origin)
                            }
                            break
                        case 'onDetailApiFail':
                            await this.sleep()
                            this.$TsaIframeDialog.hide()
                            break
                        case 'onDetailApiFailSpecial':
                            break
                        case 'onDetailApiFailSpecialToClose':
                            this.$TsaIframeDialog.hide()
                            break
                        case 'onClose':
                            
                            break
                        case 'onEditRemarkSuccess':
                            // 线上文件弹窗
                            if (fromArea === 'chooseOnlineFilesDialog') {
                                row.remark = data.remark
                                row.remarkDisplay = condition.name ? fuzzySearch(row.remark, condition.name) : row.remark
                            }
                            break
                        case 'onDeleteOriginFileSuccess':
                            // 线上文件弹窗
                            if (fromArea === 'chooseOnlineFilesDialog') {
                                row.sourceFileUploadType = data.sourceFileUploadType
                                row.sharingStatus = data.sharingStatus
                            } else if (fromArea === 'createProcess') {
                                row.storeType = data.sourceFileUploadType
                                row.sharingStatus = data.sharingStatus
                            } else if (fromArea === 'copyrightSecond') {
                                row.storeType = data.sourceFileUploadType
                                row.sharingStatus = data.sharingStatus
                            }
                            break
                        case 'onUploadOriginFileSuccess':
                            // 线上文件弹窗
                            if (fromArea === 'chooseOnlineFilesDialog') {
                                row.sourceFileUploadType = data.sourceFileUploadType
                                row.sharingStatus = data.sharingStatus
                            } else if (fromArea === 'createProcess') {
                                row.storeType = data.sourceFileUploadType
                                row.sharingStatus = data.sharingStatus
                            } else if (fromArea === 'copyrightSecond') {
                                row.storeType = data.sourceFileUploadType
                                row.sharingStatus = data.sharingStatus
                            }
                            break
                        case 'onShareSuccess':
                            // 线上文件弹窗
                            if (fromArea === 'chooseOnlineFilesDialog') {
                                row.sharingStatus = data.sharingStatus
                            } else if (fromArea === 'createProcess') {
                                row.sharingStatus = data.sharingStatus
                            }
                            break
                        case 'onStopShare':
                            // 线上文件弹窗
                            if (fromArea === 'chooseOnlineFilesDialog') {
                                row.sharingStatus = data.sharingStatus
                            } else if (fromArea === 'createProcess') {
                                row.sharingStatus = data.sharingStatus
                            }
                            break
                        case 'onUpdateBalance':
                            // 线上文件弹窗
                            if (fromArea === 'chooseOnlineFilesDialog') {
                                Store.dispatch('balance/getBalanceInfo')
                            } else {
                                this.getBalanceInfo()
                            }
                            
                            break
                        default:
                            break
                    }
                },
            })
        },
        // 分享
        async gotoShareCommon({row}) {
            let id = row.dataId || row.id
            this.$TsaIframeDialog.share({
                params: {
                    id
                },
                onActions: async (res) => {
                    console.log(res)
                    let { result, source, origin } = res
                    let { type, data } = result
                    switch (type) {
                        case 'onMountedFail':
                            this.$TsaIframeDialog.hide()
                            break
                        case 'onForbidden':
                            await this.sleep()
                            this.$TsaIframeDialog.hide()
                            // this.$TsaAlertV2.show({
                            //     title: '提示',
                            //     // message: '您无权使用该服务，请与主账号管理员联系授权',
                            //     message: '您无权使用该服务',
                            //     onClose: () => {
                            //         window.open(process.env.VUE_APP_ACCOUNTUI)
                            //         this.$TsaAlertV2.hide()
                            //     },
                            //     onConfirm: () => {
                            //         window.open(process.env.VUE_APP_ACCOUNTUI)
                            //         this.$TsaAlertV2.hide()
                            //         this.$TsaIframeDialog.hide()
                            //     }
                            // })
                            break
                        case 'onTimeout':
                            this.$TsaIframeDialog.hide()
                            break
                        case 'onLoginException':
                            await this.sleep()
                            this.$TsaIframeDialog.hide()
                            break
                        case 'onClose':

                            break
                        case 'onShareSuccess':
                            if (this.validValue(row.sharingStatus)) {
                                row.sharingStatus = 1
                            }
                            break
                        case 'onStopShare':
                            if (this.validValue(row.sharingStatus)) {
                                row.sharingStatus = 0
                            }
                            break
                        case 'onShareDialogOpen':
                            break
                        case 'onShareDialogClose':
                            this.$TsaIframeDialog.hide()
                            break
                        case 'onShareOpenError':
                            await this.sleep(2000)
                            this.$TsaIframeDialog.hide()
                            break
                    }
                },
            })
        },
    }
}